import type { GraphicFailureCopy } from '@/features/graphics/graphic-failure';
import { cn } from '@/lib/utils';
import { AlertTriangle, ShieldAlert } from 'lucide-react';
import type { CSSProperties } from 'react';

/**
 * What a gallery tile shows in place of the picture for a failed graphic
 * (ENG-1155): that it failed, which graphic, why, and the code to quote.
 * Shared by the desktop masonry tile and the phone grid.
 */
export function FailedGraphicTileBody({
  failure,
  name,
  className,
  style,
}: {
  failure: GraphicFailureCopy;
  name: string;
  className?: string;
  style?: CSSProperties;
}) {
  const Icon = failure.isSafetyBlock ? ShieldAlert : AlertTriangle;
  return (
    <div
      data-testid="media-tile-failed"
      style={style}
      className={cn(
        'flex w-full flex-col items-center justify-center gap-1 bg-destructive/5 px-3 text-center',
        className
      )}
    >
      <Icon className="mb-1 size-6 shrink-0 text-destructive" />
      <p className="text-sm font-medium text-destructive">Failed graphic</p>
      <p className="line-clamp-1 text-xs font-medium">{name}</p>
      <p className="line-clamp-2 text-xs text-muted-foreground">
        {failure.isSafetyBlock ? failure.title : failure.message}
      </p>
      {failure.code ? (
        <p className="font-mono text-[11px] text-muted-foreground">
          {failure.code}
        </p>
      ) : null}
    </div>
  );
}
